import { render } from "./OrderScan.vue?vue&type=template&id=2b8945e7&scoped=true&ts=true"
import script from "./OrderScan.vue?vue&type=script&lang=ts"
export * from "./OrderScan.vue?vue&type=script&lang=ts"

import "./OrderScan.vue?vue&type=style&index=0&id=2b8945e7&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8945e7"]])

export default __exports__